// The language switch keeps your place (snippets/language-switcher.liquid).
// Without this file the form already works: Shopify sends you to the same page in the chosen language. This adds the
// query and the hash (search terms, a chosen variant, the chapter you jumped to) and skips the round trip when you
// pick the language you already read. Loaded as a module, so it runs once however often the snippet renders.
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

/** The current path without the language prefix ('/en/pages/faq' becomes '/pages/faq'); Shopify adds the new one. */
const unprefixed = () => {
  const path = window.location.pathname;
  if (root === '/' || !`${path}/`.startsWith(root)) return path;
  return `/${path.slice(root.length)}`;
};

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('lang')) return;
  const button = event.submitter;
  if (button && button.getAttribute('aria-current') === 'true') {
    event.preventDefault();
    return;
  }
  const field = form.querySelector('input[name="return_to"]');
  if (field) field.value = `${unprefixed()}${window.location.search}${window.location.hash}`;
});
